export const GIFT_CARD_DETAILS = {
    BALANCE_NAVIGATE_HERE_LINK : process.env.GIFT_CARD_DETAILS_BALANCE_NAVIGATE_HERE_LINK ?? 'https://app.akimbocard.com/app/#/akimbo/cardBalance',
    BALANCE_PHONE : process.env.GIFT_CARD_DETAILS_BALANCE_PHONE ?? '1-855-925-4626',
} as const;

export const GIFT_CARD_MESSAGE_LENGTH = 250;